import React from 'react';
import { BoxesLoadingDialog } from './boxes-loading-dialog/BoxesLoadingDialog';
import { BoxesUIProvider } from './BoxesUIContext';
import BoxesCard from './BoxesCard';

const BoxesPage = ({ history }) => {
  const BoxesUIEvents = {
    openViewBoxDialog: (id) => {
      history.push(`/boxes/${id}/edit`);
    },
  };

  return (
    <BoxesUIProvider BoxesUIEvents={BoxesUIEvents}>
      <BoxesLoadingDialog />
      <BoxesCard props />
    </BoxesUIProvider>
  );
};

export default BoxesPage;
